import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import loginReducer from "./LoginReducer";
import costReducer from "./CostReducer";
import managerReducer from "./ManagerReducer";
import accountingRequestReducer from "./AccountantReducer";
import reportsReducer from "./ReportsReducer";
import employeeReducer from "./EmployeeReducer";
import exchangeRateReducer from './ExchangeRateReducer';
import loadingReducer from "./LoadingReducer";

const createRootReducer = (history) => combineReducers({
  login: loginReducer,
  cost: costReducer,
  accounting: accountingRequestReducer,
  managers: managerReducer,
  reports: reportsReducer,
  employees: employeeReducer,
  exchangeRate: exchangeRateReducer,
  loading:loadingReducer,
  router: connectRouter(history)
})

export default createRootReducer;
